export const LANGUAGE_LABELS = {
  python: 'Python',
  c: 'C',
  cpp: 'C++',
  java: 'Java',
  javascript: 'JavaScript',
  typescript: 'TypeScript',
  html: 'HTML',
  css: 'CSS',
  go: 'Go',
  rust: 'Rust',
};

export const MONACO_LANGUAGE_MAP = {
  python: 'python',
  c: 'c',
  cpp: 'cpp',
  java: 'java',
  javascript: 'javascript',
  typescript: 'typescript',
  html: 'html',
  css: 'css',
  go: 'go',
  rust: 'rust',
};

export function toMonacoLanguage(language) {
  const normalized = String(language || 'python').toLowerCase();
  if (normalized === 'c') return 'c';
  if (normalized === 'cpp' || normalized === 'c++') return 'cpp';
  return MONACO_LANGUAGE_MAP[normalized] || normalized || 'plaintext';
}

export function getLanguageLabel(language) {
  return LANGUAGE_LABELS[language] || language || 'Plain Text';
}
